import React from 'react';

import { Icon } from 'apps/auth/components/common/Icon/Icon';

import { IconWrapper, ItemContainer, MenuLink, NavigationMenuText } from './styles';

interface MenuItemProps {
    isHidden?: boolean;
    isSelected: boolean;
    link: string;
    testId: string;
    iconId: string;
    title?: string;
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
    if (props.isHidden) {
        return null;
    }

    return (
        <ItemContainer isSelected={props.isSelected}>
            <MenuLink href={props.link} data-testid={`menu-side-bar-link-${props.testId}`}>
                <IconWrapper>
                    <Icon name={props.iconId} color={props.isSelected ? 'primary' : 'secondary'} />
                </IconWrapper>
                <NavigationMenuText>{props.title}</NavigationMenuText>
            </MenuLink>
        </ItemContainer>
    );
};
